module.exports = __webpack_public_path__ + "img/weddingRingsSoleil-emotion-04@2x.8a055ab.jpg";